import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { MONTHWISE_ATTENDANCE_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const MonthWiseAttendance = () => {

    const [monthWiseAttendanceData, setMonthWiseAttendance] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const monthWiseAttendanceColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "year",
            Header: "Year",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "month",
            Header: "Month",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "department",
            Header: "Department",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "working_days",
            Header: "Working Days",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "total_late_hours",
            Header: "Total Late Hours",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "present",
            Header: "Present",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "absent",
            Header: "Absent",
            Cell: ({ value }) => value ?? "-",
        },
    ];

    return (
        <ReportPageShell title="Month Wise Attendance Report " count={totalRecords}>

            <Reactable
                columns={monthWiseAttendanceColumns}
                data={monthWiseAttendanceData}
                setData={setMonthWiseAttendance}
                setTotalCount={setTotalRecords}
                url={MONTHWISE_ATTENDANCE_REPORTS}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </ReportPageShell>
    );
}

export default MonthWiseAttendance;